import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import Loader from "../../Components/Loader/Loader";
import { sportUrl } from "../../Utils/Constants";
import { errorMessage, getSports } from "../../Utils/api";
import "./Catalogue.css";

/** `/sports` — the sport index. Only sports with teams are stored, so there
 *  are no empty categories to render. */
export default function SportsIndex() {
  const [sports, setSports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Sports · NIL-Collab";
    let cancelled = false;
    getSports()
      .then((data) => {
        if (!cancelled) setSports(data);
      })
      .catch((error) => {
        if (!cancelled) toast.error(errorMessage(error, "Could not load sports"));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <Header />
      {loading ? <Loader /> : null}

      <div className="cat-page">
        <h1 className="cat-title">Sports</h1>
        <p className="cat-sub">Browse athletes by sport, conference and team</p>

        <div className="cat-team-grid">
          {sports.map((s) => (
            <Link key={s.sport_id} to={sportUrl(s.slug)} className="cat-team-card">
              <div className="cat-team-logo-fallback" aria-hidden="true">
                {s.sport_name.charAt(0)}
              </div>
              <span className="cat-team-name">
                {s.sport_name}
                <span className="cat-team-count">{s.team_count} teams</span>
              </span>
            </Link>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}
